import { WFCMSList } from '@xatom/cmslist';
import { WFDynamicList, WFFormComponent } from '@xatom/core';
import { capitalizeWords, checkIfWordsExist, separateSetIntoWords } from './utilities';
import { ATTRS } from './config';
import { AllMarkersType, CoreLibrary, GoogleMap, Markers } from './types';

type MasterFilterList = {
	label: string;
	values: string[];
};

export const initMap = (maps: GoogleMap, markers: Markers, core: CoreLibrary) => {
	const mapHolder = document.querySelector<HTMLDivElement>(ATTRS.mapHolder);
	if (!mapHolder) throw new Error(`Map holder element not found: ${ATTRS.mapHolder}`);

	const form = new WFFormComponent(ATTRS.filterForm);
	const masterFilterList = new WFDynamicList<MasterFilterList>(form.getChildAsComponent(ATTRS.filterGroup), {
		rowSelector: ATTRS.checkboxGroup,
	});

	const map = new maps.Map(mapHolder, {
		center: { lat: 37.7749, lng: -122.4194 },
		zoom: 10,
		mapId: '5d3dc3e2d0494bda',
		fullscreenControl: true,
		zoomControl: true,
		scaleControl: false,
		cameraControl: false,
		mapTypeControl: false,
		streetViewControl: false,
		rotateControl: false,
	});
	const allMarkers: AllMarkersType[] = [];
	let mapBound = new core.LatLngBounds();

	function setMapBound(currentItems: AllMarkersType[]) {
		const visibleMarkers = currentItems.filter(element => element.marker.map === map);
		if (visibleMarkers.length === 0) return;

		visibleMarkers.forEach(element => {
			const { marker } = element;
			mapBound.extend(marker.position);
		});

		if (visibleMarkers.length <= 2) {
			const { marker } = visibleMarkers[0];
			map.setCenter(marker.position);
			map.setZoom(14);
		} else {
			map.fitBounds(mapBound);
		}
	}

	const infoWindow = new google.maps.InfoWindow({
		content: ``,
		maxWidth: 400,
		headerDisabled: true,
	});
	infoWindow.close();
	const cms = new WFCMSList(ATTRS.cmsList, {
		autoLoadAllItems: true,
		numberOfItemPerPage: 100000,
		removeNativePaginationElements: true,
	});

	cms.onAllCollectionItemsReady(() => {
		const items = cms.getAllItems();
		const itemsWithDataSet = items
			.map(item => item.getCloneAsComponent())
			.map(item => ({
				data: item.getElement().dataset,
				item,
				pin: item.getChildAsComponent(ATTRS.pin),
				content: item.getChildAsComponent(ATTRS.content),
			}));

		const filters = new Map<string, Set<string>>();

		itemsWithDataSet.forEach(item => {
			Object.keys(item.data).forEach(key => {
				const match = key.match(/^filter([A-Z][a-zA-Z]*)/);
				if (match) {
					const label = match[1];
					if (!filters.has(label)) {
						filters.set(label, new Set<string>());
					}
					filters.get(label)!.add(item.data[key]);
				}
			});
			const lat = parseFloat(item.data.lat);
			const lng = parseFloat(item.data.lng);
			const marker = new markers.AdvancedMarkerElement({
				map,
				gmpClickable: true,
				title: item.data.title,
				content: item.pin.getElement(),
				position: {
					lat: lat,
					lng: lng,
				},
			});
			marker.addListener('click', () => {
				infoWindow.setContent(item.content.getElement());
				infoWindow.setPosition(marker.position);
				infoWindow.open(map);
			});
			mapBound.extend(marker.position);
			allMarkers.push({ marker, item });
		});

		setMapBound(allMarkers);
		let tempFilterListData: MasterFilterList[] = [];

		filters.forEach((filterSet, label) => {
			const filterArray = Array.from(filterSet);
			tempFilterListData.push({ label, values: filterArray });
		});
		masterFilterList.setData(tempFilterListData);
	});

	map.addListener('click', () => infoWindow.close());

	form.on('change', () => {
		const data = form.getFormData();
		mapBound = new core.LatLngBounds();
		const dataValues = Object.keys(data);

		allMarkers.forEach(element => {
			const { item, marker } = element;
			let matchFound = false;

			Object.keys(item.data).forEach(key => {
				if (key.startsWith('filter')) {
					if (checkIfWordsExist(item.data[key], dataValues)) {
						matchFound = true;
						mapBound.extend(marker.position);
					}
				}
			});
			marker.map = matchFound ? map : null;
		});

		setMapBound(allMarkers);
	});

	//do nothing on submit
	form.onFormSubmit(data => {});

	masterFilterList.rowRenderer(({ rowData, rowElement }) => {
		const { label, values } = rowData;

		const clonedList = rowElement.getCloneAsComponent();
		const labelTemplate = clonedList.getChildAsComponent(ATTRS.filterLabel);
		labelTemplate.setTextContent(label);

		const checkBoxField = clonedList.getChildAsComponent(ATTRS.checkboxField);

		const uniqueValues = separateSetIntoWords(values);
		uniqueValues.map(value => {
			const clonedCheckBoxField = checkBoxField.getCloneAsComponent();
			const input = clonedCheckBoxField.getChildAsComponent('input');
			const text = clonedCheckBoxField.getChildAsComponent('.w-form-label');

			input.setAttribute('id', value);
			input.setAttribute('name', value);
			input.setAttribute('data-name', value);
			text.setTextContent(capitalizeWords(value));
			text.setAttribute('for', value);
			clonedList.appendChild(clonedCheckBoxField);
		});
		checkBoxField.remove();
		masterFilterList.appendChild(clonedList);

		return null;
	});
	masterFilterList.setData([]);
};
